import React, {createContext, ReactNode, useEffect, useState} from "react";
import {LoginResponsePayload} from "../interfaces";
import {useAppDispatch} from "../reducers/hooks";

interface AuthContextType {
    accessData: LoginResponsePayload | null,
    login: (login: LoginResponsePayload) => void,
    logout: () => void
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({children}) => {
    const [accessData, setAccessData] = useState<LoginResponsePayload | null>(null)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (localStorage.getItem("access_token") !== null) {
            let access_token = localStorage.getItem("access_token") ? localStorage.getItem("access_token")! : ""
            let expires_at = localStorage.getItem("expires_at") ? parseInt(localStorage.getItem("expires_at")!) : 0
            let id = localStorage.getItem("id") ? localStorage.getItem("id")! : ""
            let languageTag = localStorage.getItem("languageTag") ? localStorage.getItem("languageTag")! : ""
            let refresh_token = localStorage.getItem("refresh_token") ? localStorage.getItem("refresh_token")! : ""
            let role = localStorage.getItem("role") ? localStorage.getItem("role")! : ""
            let username = localStorage.getItem("username") ? localStorage.getItem("username")! : ""

            let storedAccessData: LoginResponsePayload = {
                access_token: access_token,
                expires_at: expires_at,
                id: id,
                languageTag: languageTag,
                refresh_token: refresh_token,
                role: role,
                username: username
            }

            setAccessData(storedAccessData)
        }

    }, []);

    const login = (accessData: LoginResponsePayload) => {
        console.log("LOGIN")
        localStorage.setItem("access_token", accessData.access_token)
        localStorage.setItem("expires_at", accessData.expires_at.toString())
        localStorage.setItem("id", accessData.id)
        localStorage.setItem("languageTag", accessData.languageTag)
        localStorage.setItem("refresh_token", accessData.refresh_token)
        localStorage.setItem("role", accessData.role)
        localStorage.setItem("username", accessData.username)

        setAccessData(accessData)
    }

    const logout = () => {
        console.log("LOGOUT")
        localStorage.removeItem("access_token")
        localStorage.removeItem("expires_at")
        localStorage.removeItem("id")
        localStorage.removeItem("languageTag")
        localStorage.removeItem("refresh_token")
        localStorage.removeItem("role")
        localStorage.removeItem("username")

        setAccessData(null)
        dispatch({type: 'reset'})
    }

    return (
        <AuthContext.Provider value={{accessData, login, logout}}>
            {children}
        </AuthContext.Provider>
    )
}